import React from 'react'
import intl from 'react-intl-universal'
import styled from 'styled-components'
import { Flex, Button, Link } from '@raysync/common/components'
import { Devices } from '@raysync/common/theme'
import { Navigation } from '@raysync/common/services'
import DownloadIcon from '@raysync/common/components/svg/docs-download'
import card1 from './card1.png'
import card2 from './card2.png'
const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 56px 0;
  @media ${Devices.phone} {
    margin: 0.6rem 0;
  }
`

const Card = styled.div`
  width: 448px;
  &:nth-child(1) {
    margin-right: 30px;
  }
  @media ${Devices.phone} {
    width: 100%;
    &:nth-child(1) {
      margin-right: unset;
      margin-bottom: 0.3rem;
    }
  }
`

const CardImage = styled.div`
  height: 210px;
  background-size: cover;
  background-position: center center;
  @media ${Devices.phone} {
    height: 3rem;
  }
`

const CardContent = styled.div`
  border-radius: 2px;
  background: #fff;
  padding: 30px;
  box-shadow: 0px 2px 6px 0px rgba(37, 42, 58, 0.14);
  @media ${Devices.phone} {
    padding: 0.3rem;
  }
`

const CardTitle = styled.p`
  font-size: 24px;
  line-height: 1;
  margin-bottom: 28px;
  color: ${p => p.theme.color.textDarkPlus};
  @media ${Devices.phone} {
    font-size: 0.3rem;
    margin-bottom: 0.3rem;
  }
`

const CardButton = styled.span`
  display: flex;
  color: ${p => p.theme.color.secondary};
  cursor: pointer;
  line-height: 16px;
  svg {
    width: 14px;
    height: 14px;
    margin: 0 8px 2px 0;
  }
  @media ${Devices.phone} {
    font-size: 0.3rem;
  }
`

const Cards = () => {
  const items = [
    { title: intl.get('solution.sdk.resources.js-sdk'), image: card1 },
    { title: intl.get('solution.sdk.resources.api'), image: card2 },
  ]
  return (
    <>
      <CardWrapper>
        {items.map(({ image, title }, index) => (
          <Card key={index}>
            <CardImage style={{ backgroundImage: `url(${image})` }} />
            <CardContent>
              <CardTitle>{title}</CardTitle>
              <CardButton
                onClick={() => {
                  Navigation.toApply({ type: 'solution' })
                }}
              >
                <DownloadIcon />
                {intl.get('solution.sdk.request-download')}
              </CardButton>
            </CardContent>
          </Card>
        ))}
      </CardWrapper>

      <Flex>
        <Link to='/support/document/'>
          <Button variant='outlined' size='large'>
            {intl.get('app.document.download.more')}
          </Button>
        </Link>
      </Flex>
    </>
  )
}

export default Cards
